import { usePermissionsCatalog } from '@shared/hooks'
import { buildPermissionSections } from '@shared/utils'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

/**
 * Secțiunile de permisiuni pentru toate aplicațiile instalate.
 *
 * Cheile opțiunilor sunt prefixate cu id-ul aplicației, pentru că aplicații diferite
 * pot expune aceeași cheie de permisiune.
 */
export const useApplicationPermissionSections = () => {
  const { t } = useTranslation()
  const { catalogs, isLoading } = usePermissionsCatalog()

  const sections = useMemo(
    () =>
      buildPermissionSections({
        catalogs,
        otherLabel: t('permissions.category_other')
      }),
    [catalogs, t]
  )

  return { sections, isLoading }
}
